import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { createBulkTask, endBulkTask } from '../../store/actions/people';

import BulkTasksModal from 'components/modals/bulk_tasks_modal';

export class PeopleBulkTasksModal extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.array.isRequired,
    currentUser: PropTypes.object.isRequired,
    databaseMembers: PropTypes.array.isRequired,
    people: PropTypes.array.isRequired,
    selectedPersonIds: PropTypes.array.isRequired,
    startBulkTasks: PropTypes.bool.isRequired,
    onCancelBulkTasks: PropTypes.func.isRequired,
    onCreateBulkTasks: PropTypes.func.isRequired
  };

  handleBulkTasks = (task) => {
    const { selectedPersonIds, onCancelBulkTasks, onCreateBulkTasks } = this.props;
    onCreateBulkTasks(task, selectedPersonIds);
    onCancelBulkTasks();
  }

  getPerson(id) {
    return this.props.people.find(person => (
      person.id === id
    ));
  }

  render() {

    const {
      availableDatabases,
      currentUser,
      selectedPersonIds,
      startBulkTasks,
      databaseMembers,
      onCancelBulkTasks
    } = this.props;

    const selectedContacts = [];
    selectedPersonIds.forEach((id) => {
      const person = this.getPerson(id) || { id: id, unloaded: true };
      selectedContacts.push(person);
    });

    const defaultAssociatedModels = [
      {
        associatedModelId: 1,
        associatedModelType: "Multiple",
        name: "Multiple Contacts",
        default: true
      }
    ];

    return (
      <BulkTasksModal
        availableDatabases={availableDatabases}
        currentUser={currentUser}
        databaseMembers={databaseMembers}
        defaultAssociatedModels={defaultAssociatedModels}
        selectedContacts={selectedContacts}
        shown={startBulkTasks}
        onCancel={onCancelBulkTasks}
        onSubmit={this.handleBulkTasks}
      />
    );
  }
}

const mapStateToProps = state => ({
  availableDatabases: state.static.availableDatabases,
  currentUser: state.static.currentUser,
  databaseMembers: state.people.databaseMembers,
  people: state.search.people,
  selectedPersonIds: state.selectList.selectedPersonIds,
  startBulkTasks: state.people.startBulkTasks
});

const mapDispatchToProps = {
  onCancelBulkTasks: endBulkTask,
  onCreateBulkTasks: createBulkTask,
};

export default connect(mapStateToProps, mapDispatchToProps)(PeopleBulkTasksModal);
